
const digest = '9b77ea5ad94cca70f447a23720bfcc0313fffbbe10a18b36a6065047c4c05ddf';
const classes = {"wrapper":"_wrapper_iis3k_1","flatWrapper":"_flatWrapper_iis3k_5"};
const css = `._wrapper_iis3k_1 {
  height: 100%;
}

._flatWrapper_iis3k_5 {
  overflow: visible !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  